// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Tabs';
export { default as Tab } from './Tab';
export { default as SearchBar } from './SearchBar';



// WEBPACK FOOTER //
// ./components/Tabs/index.js